// extracted by mini-css-extract-plugin
export default {"arrowIcon":"z3SJ3E","withNewColorWiring":"fFWxB3","arrowWrapper":"c4iU97","arrow":"Cg44ot"};